'use client'

import {
  ResponsiveModal,
  ResponsiveModalContent,
  ResponsiveModalTitle,
} from '@/components/extension/responsive-modal'
import { useTranslations } from 'next-intl'
import { useCallback } from 'react'
import { ProductInfoSuggestAllItem } from './product-info-suggest-all-item'
import { BasicProductInfo } from './product-info-suggest-modal'

interface ProductInfoSuggestAllModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  products: BasicProductInfo[]
  previewToken?: string
}

export const ProductInfoSuggestAllModal = ({
  open,
  onOpenChange,
  products,
  previewToken,
}: ProductInfoSuggestAllModalProps) => {
  const t = useTranslations('product_detail.title')

  // Handler để prevent modal đóng khi PhotoSwipe đang mở
  const handleInteractOutside = useCallback((e: Event) => {
    // Check xem click có phải từ PhotoSwipe container không
    const target = e.target as HTMLElement
    if (target?.closest('.pswp')) {
      e.preventDefault()
    }
  }, [])

  // Handler để prevent modal đóng khi nhấn Escape và PhotoSwipe đang mở
  const handleEscapeKeyDown = useCallback((e: KeyboardEvent) => {
    // Check xem PhotoSwipe có đang mở không
    const pswpElement = document.querySelector('.pswp')
    if (pswpElement && pswpElement.classList.contains('pswp--open')) {
      e.preventDefault()
    }
  }, [])

  return (
    <ResponsiveModal open={open} onOpenChange={onOpenChange}>
      <ResponsiveModalContent
        className='z-[102] flex flex-col gap-0 border-none p-4 lg:h-[90vh] lg:w-[1064px] lg:max-w-full lg:rounded-md lg:p-7'
        aria-describedby={'modal-view-all-suggests'}
        onInteractOutside={handleInteractOutside}
        onEscapeKeyDown={handleEscapeKeyDown}
      >
        <ResponsiveModalTitle className='mb-4.5 flex-shrink-0 font-criteria text-sm font-semibold uppercase leading-7 text-black'>
          {t('worn_together')}
        </ResponsiveModalTitle>
        <div className='no-scrollbar flex-1 overflow-y-auto'>
          <div className='flex flex-col gap-8 pr-2'>
            {products.map((product) => (
              <ProductInfoSuggestAllItem
                key={product.id}
                product={product}
                previewToken={previewToken}
              />
            ))}
          </div>
        </div>
      </ResponsiveModalContent>
    </ResponsiveModal>
  )
}
